import loadable from '@nordvpn/teams.core/lib/tools/loadable';
import { RouteGenerator } from 'routing/RouteGenerator';
import { PermissionsEnum } from 'types/permissions/enums';
import { RESELLERS_LIST_PATH, RESELLER_ORGANIZATIONS_LIST_PATH } from './constants';
var ResellersList = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/ResellersList');
});
var ResellerOrganizations = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/ResellerOrganizations');
});
export var ResellersRouting = function ResellersRouting() {
    return RouteGenerator({
        list: {
            path: RESELLERS_LIST_PATH,
            component: ResellersList,
            exact: true
        },
        organizations: {
            path: RESELLER_ORGANIZATIONS_LIST_PATH,
            component: ResellerOrganizations,
            exact: true,
            permission: PermissionsEnum.ResellersManagement
        }
    });
};
